import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const getToken = () => {
  const token = localStorage.getItem('token');

  return token;
};

export const subpoenaList = [];

const mapResponse = item => ({
  id: item.id,
  journalName: item.nome_jornal,
  treatmentDate: item.data_tratamento,
  availabilityDate: item.data_disponibilizacao_publicacao,
  text: item.texto_publicacao,
  title: item.titulo,
  publicationNumber: item.numero_publicacao,
  fileNumber: item.numero_arquivo,
  header: item.cabecalho,
  footer: item.rodape,
  status: item.status,
  isLabor: item.is_labor,
  createdAt: item.created_at,
});

export const useSubpoenaList = () => {
  const [subpoenas, setSubpoena] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [unread, setUnread] = useState();

  const setSubpoenasStatus = useCallback((ids, status) => {
    setSubpoena(prev => {
      const shallow = prev.slice();

      shallow.forEach(item => {
        if (ids.includes(item.id)) {
          item.status = status;
        }
      });

      return shallow;
    });
  }, []);

  const fetchSubpoena = useCallback(async (page = 1) => {
    setIsLoading(true);
    try {
      const token = getToken();
      let res;
      if (token) {
        const response = await axios.get('/user/aasp-records?page=' + page, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        res = response && response.data;
      } else {
        res = subpoenaList;
      }

      let count = 0;
      for (let i = 0; i < res.length; i++) {
        if (res[i].status === 'UNREAD') count++;
      }
      if (count > 0) {
        setUnread(count);
      }

      return res.map(mapResponse);
    } catch (err) {
      return subpoenaList.map(mapResponse);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    async function getSubpoenas() {
      const subpoenas = await fetchSubpoena();

      setSubpoena(subpoenas);
    }

    getSubpoenas();
  }, [fetchSubpoena]);

  return { subpoenas, isLoading, setSubpoenasStatus, unread };
};

export const markSubpoenaAs = async (record_ids, status) => {
  try {
    const token = getToken();

    await axios.put(
      '/user/aasp-records/status',
      {
        record_ids,
        status,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return true;
  } catch (err) {
    return false;
  }
};
